module.exports = __webpack_public_path__ + "static/media/HCMM514.a60e3bdc.jpg";